export const TRANSLATIONS = {
    EN: {
        EASY_LIQUIDATION_BV: {
            NEXT_STEP: 'Next step',
            COMPANY_DATA: {
                LEGAL_FORM: 'Legal form',
                KVK_NUMBER: 'Chamber of Commerce',
                FOREIGN_COMPANY_ID: 'Organization registration number',
                ZIP_CODE: 'Zip Code',
                HOUSE_NUMBER: 'House number',
                STREET: 'Street',
                CITY: 'City',
                OPTIONS: {
                    BV: 'BV',
                    FOUNDATION: 'Foundation',
                    ASSOCIATION: 'Association',
                    OTHERS: 'Others',
                },
            },
            SHAREHOLDERS: {
                HOW_MANY: 'How many shareholders?',
            },
        },
        EASY_BV: {
            INTRO: {
                TITLE: 'Good choice! The 1-Person BV.',
                DESCRIPTION: 'Because you meet the criteria, we can offer you a simplified incorporation process. This has the following advantages:',
                START: 'Start your BV incorporation',
                ITEMS: [
                    {
                        TITLE: 'Fixed price, no surprises.',
                        TOOLTIP:
                            'The 1-Person BV has the advantage that we only need to ask you a few questions to show you a price overview. This way you immediately know where you stand.',
                    },
                    {
                        TITLE: 'Fully digital incorporation process.',
                        TOOLTIP:
                            'The incorporation of the BV is completely digital! Through your personal dashboard, you are always in contact with the notary and you can also upload all the necessary documents.',
                    },
                    {
                        TITLE: 'A lightning-fast private limited company formation.',
                        TOOLTIP:
                            'Together with the notaries, we have made the incorporation process of the 1-Person BV so efficient that you can incorporate your limited company (if desired) within 48 hours!',
                    },
                    {
                        TITLE: 'Automatic registration with the CoC and the Tax Authorities.',
                        TOOLTIP:
                            'After the incorporation of the BV, you will automatically receive a C0C number and an extract. You will also be registered with the Tax Authorities and if necessary, you will receive a VAT number. If you register the BV as an employer (you can fill this in after payment), you will also automatically receive a payroll tax number.',
                    },
                ],
            },
            VARIANT_INTRO: {
                TITLE: 'The 1-Person BV, a great choice!',
                DESCRIPTION:
                    'The 1-Person BV is a simplified incorporation that we can offer because you meet our criteria. This has the following advantages:',
                NEXT_STEP: 'Continue incorporation',
            },
            HOLDING: {
                TITLE: 'Have you considered a holding company?',
                SUB_TITLE: 'Yes, I want to benefit from the advantages of a personal holding.',
                DESCRIPTION:
                    'You are currently incorporating your operating BV as a natural person. However, about 7/10 entrepreneurs choose to incorporate a holding company immediately. Click on the (?) to read why.',
                TOOLTIP:
                    'If you choose for a Holding, you have a BV hierarchically above your operating company. Because of this structure, you benefit from tax advantages and protect your valuable assets such as your office, car and capital in case your BV goes bankrupt. The reason why 7/10 entrepreneurs immediately incorporate a holding company, is because it costs at least €849 later on.',
                NO_HOLDING: {
                    TITLE: 'No Holding',
                    ITEMS: ['If you do not expect to sell your company in the future or run any business risks due to e.g. employees or long-term contracts.'],
                },
                HOLDING: {
                    TITLE: 'Holding',
                    ITEMS: ['If you expect your business to grow and want to take advantage of, among other things, tax benefits and asset protection.'],
                },
            },
            DGA: {
                TITLE: 'How will you manage the DMS salary?',
                DESCRIPTION:
                    'On average, an entrepreneur spends 2 days per month on his administration. If you choose the DGA salary package, you can use this time for the growth of your company.',
                TOOLTIP:
                    "As a Director and Major Shareholder (DMS), you have to deal with the salary of €{salary}. As a DMS, you have to file a monthly tax return and draw up pay slips. This takes up a lot of time that you don't want to spend doing. That is why our tax specialists are happy to take care of this for you.",
                ONE_YEAR: '(1 year)',
                NO_DGA: {
                    TITLE: 'No, I will do it myself',
                    ITEMS: ['I will do my payroll administration myself.', 'I will do my tax return myself.', 'I will prepare my own payslips.'],
                },
                DGA: {
                    TITLE: 'Yes, save me time',
                    ITEMS: [
                        'Our tax specialists will determine a (minimum) DMS salary together with you.',
                        'We arrange your monthly payroll tax return and submit it to the tax authorities.',
                        'You receive your monthly payslip and salary statement by email.',
                    ],
                },
            },
            CONTRACTS: {
                TITLE: 'Who will draft your contracts?',
                DESCRIPTION:
                    'Your company needs contracts to cover agreements. Our lawyers and tax consultants have put together a contract package so that you do not have to buy each contract separately from a lawyer. (Please note that the contracts are only available in Dutch.)',
                TOOLTIP:
                    'With the Management & Holding contracts, you immediately have all internal agreements with yourself and the BV and thus covered all the risks. Would you also like to have all agreements for your future personnel immediately arranged? Then choose Business Complete.',
                INCLUDES: 'Includes {amount} contracts',
                NO_CONTRACTS: {
                    TITLE: 'I draft my own contracts',
                    DESCRIPTION: '0 contracts',
                    ITEMS: ['0 contracts'],
                },
                BASIC: {
                    TITLE: 'Management & Holding contracts',
                    DESCRIPTION: 'Including 9 contracts',
                    ITEMS: ['The 9 essential contracts for management'],
                },
                FULL: {
                    TITLE: 'Business Complete',
                    DESCRIPTION: 'Including 25 contracts',
                    ITEMS: ['All 25 contracts for your business in one package'],
                },
            },
            OVERVIEW: {
                INVOICE: {
                    TITLE: 'Information for the invoice',
                    DESCRIPTION:
                        'Please fill in the information for the invoice. The invoice will be in the name of the new BV. Good to know: the business costs are tax deductible. Both the VAT as the incorporation costs.',
                    TOOLTIP:
                        '1: Reclaim VAT\n' +
                        'About 2 weeks after the incorporation of the BV, you will receive a letter from the Tax Authorities containing all information and (if the BV is liable for VAT) a VAT number.\n' +
                        '\n' +
                        'Always submit the VAT return on time. With your first VAT return you can reclaim the VAT for all costs that you incurred in the preliminary phase of the BV.\n' +
                        '\n' +
                        '2: Deduct costs from profits\n' +
                        'As soon as you start developing your idea, you will already incur costs. Fortunately, all costs you incur in preparation for starting the new BV are deductible! Even if you are not yet registered with a BV in the Chamber of Commerce.\n' +
                        '\n' +
                        'Therefore keep all receipts and paid invoices so you can add these costs and deducts them from the profit made on the first corporate tax return.\n',
                    COMPANY_NAME_TOOLTIP:
                        "Operating companies often use additives such as: 'Trading', 'International', 'Services' or 'Import Export'. In consultancy you often see terms such as 'Management BV' or 'Advisory BV'. Additions such as 'Holding BV', or 'Investments BV' are often used for Holding or Personal savings BVs",
                },
                DUTCH_LANGUAGE: 'Is the representing proficient in Dutch?',
                DUTCH_LANGUAGE_DESCRIPTION: 'Please note that this refers to both reading and speaking.',
            },
        },
        START: {
            LOGIN: {
                DESCRIPTION: 'Log in to proceed.',
            },
            REGISTER: {
                USP_1: 'Stop and continue at any time with your application',
                USP_2: 'Always track the status of your incorporation',
                USP_3: 'Manage your businesses via your personal dashboard',
                CREATE_YOUR_ACCOUNT: 'Create account',
                SIGN_IN: 'Sign-in',
                PHONE_TOOLTIP:
                    'We will use your phone number only to keep you informed about your application and the notary will call you just before the incorporation of your BV.',
                EMAIL_TOOLTIP: 'We will use your email address only to keep you informed about your application.',
            },
            START_TITLE: 'What would you like to do?',
            START_PACKAGE_TITLE: 'Choose your service package',
            INCORPORATED_WITH: 'Incorporated within',
            BV: {
                TITLE: 'Incorporate BV or holding',
                DESCRIPTION: 'When you want to incorporate BV of holding.',
                ACTION: 'Start incorporation',
            },
            FOUNDATION: {
                LABEL: 'Foundation',
                TITLE: 'Foundation',
                DESCRIPTION: 'When you want to incorporate a foundation.',
                ACTION: 'Start incorporation',
            },
            EENMANSZAAK: {
                TITLE: 'Eenmanszaak',
                DESCRIPTION: 'When you want to start a sole proprietorship at the Chamber of commerce.',
                ACTION: 'Start',
            },
            LEGAL_TEST: {
                TITLE: 'Entity test',
                DESCRIPTION: 'Not sure about the right entity? Do the entity test.',
                ACTION: 'Start test',
            },
            PRODUCT_EASY_BV_CHOICE: 'Which situation suits you?',
            PRODUCT_ALL_OPTIONS_BV_TITLE: 'What would you like to do?',
            PRODUCT_ALL_OPTIONS_LIQUIDATION_TITLE: 'What would you like to do?',
            PRODUCT_ALL_OPTIONS_TITLE: 'What would you like to do?',
            PRODUCT_BV_TITLE: 'Which type of BV do you want to incorporate?',
            PRODUCT_BV_CONVERT_BV_TITLE: 'Select conversion type',
            REGULAR_BV: {
                TITLE: 'Regular BV',
                DESCRIPTION: 'Incorporate a new operating BV.',
            },
            HOLDING_BV: {
                TITLE: 'Holding company',
                DESCRIPTION: 'Incorporate a new holding BV.',
            },
            SAVINGS_BV: {
                TITLE: 'Private savings BV',
                DESCRIPTION: 'Incorporate a new private savings BV.',
            },
            HOLDING_BV_STRUCTURE: {
                TITLE: 'Holding BV structure',
                DESCRIPTION: 'Incorporate a new operating BV and a holding company.',
            },
            CONVERT_BV: {
                TITLE: 'Convert into a BV',
                DESCRIPTION: 'Convert the current sole proprietorship or VOF into a BV.',
            },
            ACTIVA_PASSIVA_TRANSACTION: {
                TITLE: 'Assets & liabilities transaction',
                DESCRIPTION: 'Easily convert the company into a BV. Always check in advance whether this option is possible in your situation.',
            },
            CONVERSION_BV_DEED_TRANSFER: {
                TITLE: 'Conversion with deed of transfer',
                DESCRIPTION:
                    'Converting the company through the "ruisende" or the "geruisloze inbreng". Always check in advance whether this option is most useful in your situation.',
            },
            CONVERSION_TEST: {
                TITLE: 'Conversion test',
                DESCRIPTION: 'Not sure about the right way to convert the company? Do the conversion test.',
            },
            PACKAGE_STARTER: {
                TITLE: 'Starter package',
                DESCRIPTION: 'If you only require the minimum service level.',
            },
            PACKAGE_PIONEER: {
                TITLE: 'Pioneer Package',
                DESCRIPTION: 'If you require basic advice and modules.',
            },
            PACKAGE_ENTREPRENEUR: {
                TITLE: 'Entrepreneur Package',
                DESCRIPTION: 'Our all_in_one package if you want to be completely unburdened.',
            },
            SPEED: {
                HOURS: 'hours',
                DAYS: 'business days',
                WEEKS: 'weeks',
                MONTHS: 'months',
            },
            SPEED_SHORT: {
                HOURS: 'H',
                DAYS: 'D',
                WEEKS: 'W',
                MONTHS: 'M',
            },
            UPSELL_SPEED_REGULAR: {
                TITLE: 'Regular',
                TITLE_2: 'Standard',
                DESCRIPTION: 'Achieved within {amount} business days',
                DESCRIPTION_2: '{amount}',
            },
            UPSELL_SPEED_MEDIUM: {
                TITLE: 'Medium',
                TITLE_2: 'Medium',
                DESCRIPTION: 'Achieved within {amount} business days',
                DESCRIPTION_2: '{amount}',
            },
            UPSELL_SPEED_FAST: {
                TITLE: 'Fast',
                TITLE_2: 'Priority',
                DESCRIPTION: 'Achieved within {amount} business days',
                DESCRIPTION_2: '{amount}',
                AVAILABLE: 'Only {amount} available today. Valid till 23:59',
                AVAILABLE_PART_1: 'Please note: only',
                AVAILABLE_PART_2: 'places available',
            },
            UPSELL_SPEED_URGENT: {
                TITLE: 'Super fast',
                TITLE_2: 'Urgent',
                DESCRIPTION: 'Achieved within {amount} hours. Note: after receiving required information.',
                DESCRIPTION_2: '{amount}',
                FOOTER: '* after identification',
                AVAILABLE: 'Only {amount} available today. Valid till 23:59',
                AVAILABLE_PART_1: 'Please note: only',
                AVAILABLE_PART_2: 'places available',
            },
            ALL_OPTIONS: {
                TITLE: 'Show all options',
                DESCRIPTION: "Can't find the correct option for your request?",
                ACTION: 'Show all',
            },
            CHANGE_COMPANY: {
                TITLE: 'Change company',
                DESCRIPTION: 'Description',
            },
            LIQUIDATION: {
                TITLE: 'Liquidation',
                DESCRIPTION: 'Description',
            },
            CHANGE_DEED_OF_INCORPORATION: {
                TITLE: 'Change deed of incorporation',
                DESCRIPTION:
                    'Do you want to change the name or activities or get capital without taxes from the BV? This can be done through an amendment to the articles of association.',
            },
            SHARE_TRANSFER: {
                TITLE: 'Share transfer',
                DESCRIPTION: 'Do you buy or sell the shares of the BV? Arrange the formal transfer via a share transfer.',
            },
            ISSUE_OF_NEW_SHARES: {
                TITLE: 'Issue of new shares',
                DESCRIPTION: 'Raise extra capital for the BV? You can easily arrange this via an issue of new shares.',
            },
            AANDELENFUSIE: {
                TITLE: 'Stock merger',
                DESCRIPTION:
                    'Have you ever started with just a BV do you want to switch to a holding structure? With a holding structure you receive many (tax) benefits.',
            },
            CERTIFICATION_SHARES_STAK: {
                TITLE: 'Certification shares (STAK)',
                DESCRIPTION: 'A STAK separates the right to profit from the voting right on the share.',
            },
            LIQUIDATION_BV: {
                TITLE: 'Liquidate a BV',
                DESCRIPTION: 'When you want to dissolve a BV.',
            },
            LIQUIDATION_FOUNDATION: {
                TITLE: 'Liquidate a Foundation',
                DESCRIPTION: 'When you want to close a Dutch Foundation.',
            },
            LIQUIDATION_ASSOCIATION: {
                TITLE: 'Liquidate a Association',
                DESCRIPTION: 'When you want to close an Association.',
            },
            EASY_BV: {
                TITLE: '1-Person BV',
                DESCRIPTION: ['1 shareholder (natural person)', 'Proficient in Dutch', 'Born and living in the Netherlands', '€ 1,20 share capital'],
                DETAILS: [
                    'You incorporate the BV with 1 shareholder. Minimum age 18 years.',
                    'You, as a person, are directly the shareholder of the new BV, not an existing holding company.',
                    'You must be proficient in Dutch. This regards speaking and reading. This will be checked by the notary.',
                    'You are officially living in The Netherlands according to the BRP (no postal address) and you are born in The Netherlands.',
                    'The BV has 120 shares with a value of €0.01 per share. Toale share capital is €1,20. This is most common.',
                ],
            },
            EASY_REGULAR_BV: {
                TITLE: 'Regular BV',
                DESCRIPTION: ['1 or more shareholders', 'Proficient in Dutch or English', 'Resident in the Netherlands', 'Optional share capital'],
                DETAILS: [
                    'You incorporate the BV with 1 or more shareholder(s). Minimum age 18 years..',
                    'You must be proficient in Dutch. This regards speaking and reading. This will be checked by the notary.',
                    'All shareholders are officially living in the Netherlands according to the BRP (no postal address).',
                ],
            },
            EASY_FOREIGNER_BV: {
                TITLE: 'Foreigner BV',
                DESCRIPTION: [
                    '1 or more shareholders',
                    'Proficient in the Dutch or English language',
                    'Not resident in the Netherlands',
                    'Optional share capital',
                ],
                DETAILS: [
                    'You will set up a BV with one or more shareholders. Minimum age 18 years.',
                    'You must be proficient in Dutch. This regards speaking and reading. This will be checked by the notary.',
                    '1 or more shareholders are not resident in the Netherlands.',
                ],
            },
            UBO_REGISTRATION: {
                TITLE: 'Ubo',
                DESCRIPTION: 'When you want to register UBO.',
            },
            JOBS: {
                TITLE: 'Other services',
                DESCRIPTION: 'Find all other services here.',
            },
        },
    },
    NL: {
        EASY_LIQUIDATION_BV: {
            NEXT_STEP: 'Volgende stap',
            COMPANY_DATA: {
                LEGAL_FORM: 'Rechtsvorm',
                KVK_NUMBER: 'KvK nummer',
                FOREIGN_COMPANY_ID: 'Registratienummer organisatie',
                ZIP_CODE: 'Postcode',
                HOUSE_NUMBER: 'Huisnummer',
                STREET: 'Straatnaam',
                CITY: 'Plaatsnaam',
                OPTIONS: {
                    BV: 'BV',
                    FOUNDATION: 'Stichting',
                    ASSOCIATION: 'Vereniging',
                    OTHERS: 'Anderen',
                },
            },
            SHAREHOLDERS: {
                HOW_MANY: 'Hoeveel aandeelhouders?',
            },
        },
        EASY_BV: {
            INTRO: {
                TITLE: 'Goede keuze! De 1-Persoons BV',
                DESCRIPTION: 'Omdat je aan de criteria voldoet kunnen wij je een versimpelde oprichting aanbieden. Dit heeft de volgende voordelen:',
                START: 'Start met je BV oprichting',
                ITEMS: [
                    {
                        TITLE: 'Een razendsnelle BV oprichting',
                        TOOLTIP:
                            'Wij hebben samen met de notarissen het oprichtingsproces van de 1-Persoons BV zo efficiënt gemaakt dat je (indien gewenst) binnen 48u je BV kunt oprichten! ',
                    },
                    {
                        TITLE: 'Vaste BV prijs, zonder verrassingen',
                        TOOLTIP:
                            'De 1-Persoons BV heeft als voordeel dat wij je maar een paar vragen hoeven te stellen om je een prijsoverzicht te laten zien. Zo weet je direct waar je aan toe bent.',
                    },
                    {
                        TITLE: 'Volledig digitaal oprichtingsproces.',
                        TOOLTIP:
                            'De oprichting van een 1-Persoons BV gaat volledig digitaal! Via je persoonlijke BV dashboard ben je altijd in contact met de notaris en kan je ook alle benodigde documenten uploaden.',
                    },
                    {
                        TITLE: 'Automatische inschrijving KvK en Belastingdienst.',
                        TOOLTIP:
                            'Na de oprichting van de BV ontvang je automatisch een KvK nummer en uittreksel. Ook wordt de BV aangemeld bij de Belastingdienst en indien nodig krijg je ook een BTW-nummer. Als je de BV als werkgever opgeeft (dit kan je invullen na betaling), krijg je ook automatisch een loonheffingennummer.',
                    },
                ],
            },
            VARIANT_INTRO: {
                TITLE: 'De 1-Persoons BV, een goede keuze!',
                DESCRIPTION:
                    'De 1-Persoons BV is een versimpelde oprichting die we kunnen aanbieden omdat je aan de criteria voldoet. Dit heeft de volgende voordelen:',
                NEXT_STEP: 'Snel verder met oprichten',
            },
            HOLDING: {
                TITLE: 'Al nagedacht over een Holding?',
                SUB_TITLE: 'Ja, ik wil profiteren van de voordelen van een Holding.',
                TOOLTIP:
                    'Als je kiest voor een Holding heb je hiërarchisch een BV boven je werkmaatschappij. Door deze structuur profiteer je van belastingvoordelen en bescherm je jouw waardevolle activa zoals je bedrijfspand, auto en kapitaal voor het geval dat je BV failliet gaat. De reden waarom 7/10 ondernemers direct een holding oprichten is omdat dit later minimaal €849 kost.',
                DESCRIPTION:
                    'Je richt momenteel de BV op als natuurlijk persoon. Echter kiest ongeveer 7/10 ondernemers ervoor om ook direct een holding op te richten. Klik op de (?) om te lezen waarom.',
                NO_HOLDING: {
                    TITLE: 'Geen holding',
                    ITEMS: [
                        'Als je niet verwacht je bedrijf in de toekomst te verkopen of ondernemingsrisico te lopen door bijv. personeel of langdurige contracten.',
                    ],
                },
                HOLDING: {
                    TITLE: 'Holding',
                    ITEMS: ['Als je verwacht dat je bedrijf gaat groeien en wilt profiteren van o.a. belastingvoordelen en bescherming van je activa.'],
                },
            },
            DGA: {
                TITLE: 'Hoe ga je het DGA salaris regelen?',
                DESCRIPTION:
                    'Gemiddeld besteedt een ondernemer 2 dagen per maand aan zijn administratie. Als je het DGA salaris pakket kiest kan je deze tijd gebruiken voor de groei van je bedrijf.',
                TOOLTIP:
                    'Als directeur-grootaandeelhouder krijg je te maken met het DGA-salaris van €{salary}. Als DGA moet je maandelijks aangifte doen en loonstroken opmaken. Dit kost onnodig veel tijd en heb je helemaal geen zin in. Daarom regelen onze fiscalisten dit graag voor je.',
                ONE_YEAR: '(1 jaar)',
                NO_DGA: {
                    TITLE: 'Nee, ik doe het zelf',
                    ITEMS: ['Ik ga zelf mijn salarisadministratie doen.', 'Ik ga zelf mijn belastingaangifte doen.', 'Ik stel zelf mijn eigen loonstroken op.'],
                },
                DGA: {
                    TITLE: 'Ja, bespaar mij tijd',
                    ITEMS: [
                        'Onze fiscalisten bepalen samen met jou een (minimum) DGA salaris.',
                        'Wij regelen je maandelijkse loonaangifte en dienen deze in bij de Belastingdienst.',
                        'Je ontvangt maandelijks je loonstrook en salaris aangifte per e-mail.',
                    ],
                },
            },
            CONTRACTS: {
                TITLE: 'Wie gaat je contracten opstellen?',
                DESCRIPTION:
                    'Je bedrijf heeft contracten nodig om straks overeenkomsten te dekken. Onze juristen en fiscalisten hebben een contracten pakket samengesteld zodat je niet elk contract apart bij een advocaat hoeft te kopen.',
                TOOLTIP:
                    'Met het management & holding pakket heb je alle interne afspraken met jezelf en de BV direct goed geregeld en daarmee alle risico’s afgedekt. Wil je direct ook alle overeenkomsten voor je toekomstige personeel geregeld hebben? Kies dan het business compleet pakket.',
                INCLUDES: 'Inclusief {amount} contracten',
                NO_CONTRACTS: {
                    TITLE: 'Ik stel zelf mijn contracten op',
                    DESCRIPTION: '0 contracten',
                    ITEMS: ['0 contracten'],
                },
                BASIC: {
                    TITLE: 'Management & holding contracten',
                    DESCRIPTION: 'Inclusief 9 contracten',
                    ITEMS: ['De 9 essentiële contracten voor het management'],
                },
                FULL: {
                    TITLE: 'Business compleet',
                    DESCRIPTION: 'Inclusief 25 contracten',
                    ITEMS: ['Alle 25 contracten voor je bedrijf in één pakket'],
                },
            },
            OVERVIEW: {
                INVOICE: {
                    TITLE: 'Informatie voor de factuur',
                    DESCRIPTION:
                        'Vul de gegevens voor de factuur in. De factuur komt op naam van de nieuwe BV te staan. Goed om te weten: de zakelijke kosten zijn fiscaal aftrekbaar. Zowel de BTW als de oprichtingskosten.',
                    TOOLTIP:
                        '1: BTW terugvragen Ongeveer 2 weken na de oprichting van de BV ontvangt u een brief van de Belastingdienst met alle gegevens en (als de BV BTW-plichtig is) een BTW-nummer. Dien de btw-aangifte altijd op tijd in. Bij uw eerste btw-aangifte kunt u de btw terugvragen voor alle kosten die u in het voortraject van de BV heeft gemaakt. 2: Trek kosten af van de winst Zodra u begint met de ontwikkeling van uw idee, maakt u al kosten. Gelukkig zijn alle kosten die u maakt ter voorbereiding op het starten van de nieuwe BV aftrekbaar! Ook als u nog niet met een BV staat ingeschreven bij de Kamer van Koophandel. Bewaar daarom alle bonnetjes en betaalde facturen, zodat u deze kosten kunt optellen en aftrekken van de gemaakte winst bij de eerste aangifte vennootschapsbelasting.',
                    COMPANY_NAME_TOOLTIP:
                        "Exploitatiemaatschappijen gebruiken vaak toevoegingen als: 'Handel', 'Internationaal', 'Dienstverlening' of 'Import Export'. In de consultancy zie je vaak termen als 'Management BV' of 'Advies BV'. Toevoegingen als 'Holding BV', of 'Investments BV' worden vaak gebruikt voor Holding of Personal savings BV's",
                },
                DUTCH_LANGUAGE: 'Nederlandse taal goed machtig?',
                DUTCH_LANGUAGE_DESCRIPTION: 'Let op: dit geldt voor zowel lezen als spreken',
            },
        },
        START: {
            LOGIN: {
                DESCRIPTION: 'Log in om verder te gaan.',
            },
            REGISTER: {
                USP_1: 'Op ieder moment stoppen en verdergaan met jouw aanvraag',
                USP_2: 'Volg altijd de status van jouw oprichting',
                USP_3: 'Beheer je bedrijven via jouw persoonlijke dashboard',
                CREATE_YOUR_ACCOUNT: 'Aanmelden',
                SIGN_IN: 'Inloggen',
                PHONE_TOOLTIP:
                    'Wij gebruiken jouw telefoonnummer alleen om je op de hoogte te houden van de status van je aanvraag en de notaris heeft deze nodig om contact met je op te nemen vlak vóór de oprichting.',
                EMAIL_TOOLTIP: 'Wij gebruiken jouw e-mailadres om je op de hoogte te houden van de afhandeling van je aanvraag.',
            },
            START_TITLE: 'Wat wil je doen?',
            START_PACKAGE_TITLE: 'Kies de service die bij je past',
            INCORPORATED_WITH: 'Opgericht binnen',
            BV: {
                TITLE: 'BV of holding oprichten',
                DESCRIPTION: 'Wanneer je een BV of holding wilt oprichten.',
                ACTION: 'Start oprichting',
            },
            FOUNDATION: {
                LABEL: 'Stichting',
                TITLE: 'Een stichting oprichten',
                DESCRIPTION: 'Wanneer je een stichting wilt oprichten.',
                ACTION: 'Start oprichting',
            },
            EENMANSZAAK: {
                TITLE: 'Eenmanszaak',
                DESCRIPTION: 'Wanneer je een eenmanszaak digitaal wilt inschrijven bij de Kamer van Koophandel.',
                ACTION: 'Start',
            },
            LEGAL_TEST: {
                TITLE: 'Doe de rechtsvormkeuze test',
                DESCRIPTION: 'Niet helemaal zeker welke rechtsvorm je moet hebben? Doe de rechtsvormkeuzetest.',
                ACTION: 'Start test',
            },
            PRODUCT_EASY_BV_CHOICE: 'Welke situatie past bij jou?',
            PRODUCT_ALL_OPTIONS_BV_TITLE: 'Wat wil je doen?',
            PRODUCT_ALL_OPTIONS_LIQUIDATION_TITLE: 'Wat wil je doen?',
            PRODUCT_ALL_OPTIONS_TITLE: 'Wat wil je doen?',
            PRODUCT_BV_TITLE: 'Wat voor type BV wil je oprichten?',
            PRODUCT_BV_CONVERT_BV_TITLE: 'Selecteer type omzetting',
            REGULAR_BV: {
                TITLE: 'Standaard BV',
                DESCRIPTION: 'Een nieuwe BV oprichten.',
            },
            HOLDING_BV: {
                TITLE: 'Holding',
                DESCRIPTION: 'Een nieuwe holding oprichten.',
            },
            SAVINGS_BV: {
                TITLE: 'Spaar BV',
                DESCRIPTION: 'Een nieuwe spaar BV oprichten.',
            },
            HOLDING_BV_STRUCTURE: {
                TITLE: 'Holding BV structuur',
                DESCRIPTION: 'Een nieuwe BV en holding oprichten.',
            },
            CONVERT_BV: {
                TITLE: 'Onderneming omzetten naar een BV',
                DESCRIPTION: 'Huidige eenmanszaak of VOF omzetten naar een BV.',
            },
            ACTIVA_PASSIVA_TRANSACTION: {
                TITLE: 'Activa passiva transactie',
                DESCRIPTION: 'Eenvoudig de onderneming omzetten naar een BV. Controleer altijd vooraf of deze optie mogelijk is voor jou.',
            },
            CONVERSION_BV_DEED_TRANSFER: {
                TITLE: 'Oprichting met inbrengakte',
                DESCRIPTION: 'De onderneming omzetten via de ruisende of geruisloze inbreng. Controleer altijd vooraf of deze optie mogelijk is voor jou.',
            },
            CONVERSION_TEST: {
                TITLE: 'Conversion test',
                DESCRIPTION: 'Convertion test',
            },
            PACKAGE_STARTER: {
                TITLE: 'Starter Pakket',
                DESCRIPTION: 'Als je alleen de absolute basis wilt.',
            },
            PACKAGE_PIONEER: {
                TITLE: 'Pioner Pakket',
                DESCRIPTION: 'Als je een volledige service wilt met standaard advies en modules.',
            },
            PACKAGE_ENTREPRENEUR: {
                TITLE: 'Entrepreneur Pakket',
                DESCRIPTION: 'Ons alles_in_één pakket voor als je volledig ontzorgd wilt worden.',
            },
            SPEED: {
                HOURS: 'uur',
                DAYS: 'werkdagen',
                WEEKS: 'weken',
                MONTHS: 'maanden',
            },
            SPEED_SHORT: {
                HOURS: 'u',
                DAYS: 'd',
                WEEKS: 'W',
                MONTHS: 'M',
            },
            UPSELL_SPEED_REGULAR: {
                TITLE: 'Standaard',
                TITLE_2: 'Standaard',
                DESCRIPTION: 'Binnen {amount} werkdagen geregeld',
                DESCRIPTION_2: '{amount}',
            },
            UPSELL_SPEED_MEDIUM: {
                TITLE: 'Medium',
                TITLE_2: 'Medium',
                DESCRIPTION: 'Binnen {amount} werkdagen geregeld',
                DESCRIPTION_2: '{amount}',
            },
            UPSELL_SPEED_FAST: {
                TITLE: 'Snel',
                TITLE_2: 'Snel',
                DESCRIPTION: 'Binnen {amount} werkdagen geregeld',
                DESCRIPTION_2: '{amount}',
                AVAILABLE: 'Nog maar {amount} beschikbaar vandaag. Geldig tot 23:59 uur.',
                AVAILABLE_PART_1: 'Let op: nog',
                AVAILABLE_PART_2: 'plekken beschikbaar',
            },
            UPSELL_SPEED_URGENT: {
                TITLE: 'Spoed',
                TITLE_2: 'Spoed',
                DESCRIPTION: 'Binnen {amount} uur geregeld. Let op: na ontvangst benodigde informatie.',
                DESCRIPTION_2: '{amount}',
                FOOTER: '* vanaf moment legalisatie',
                AVAILABLE: 'Nog maar {amount} beschikbaar vandaag. Geldig tot 23:59 uur.',
                AVAILABLE_PART_1: 'Let op: nog',
                AVAILABLE_PART_2: 'plekken beschikbaar',
            },
            ALL_OPTIONS: {
                TITLE: 'All options',
                DESCRIPTION: 'Description',
                ACTION: 'View all',
            },
            CHANGE_COMPANY: {
                TITLE: 'Change company',
                DESCRIPTION: 'Description',
            },
            LIQUIDATION: {
                TITLE: 'Liquidation',
                DESCRIPTION: 'Description',
            },
            CHANGE_DEED_OF_INCORPORATION: {
                TITLE: 'Statutenwijziging',
                DESCRIPTION: 'Wil je de naam of doel wijzigen of kapitaal onbelast uit de BV halen? Dit kan via een statutenwijziging.',
            },
            SHARE_TRANSFER: {
                TITLE: 'Aandelenoverdracht',
                DESCRIPTION: 'Koop of verkoop je de aandelen van de BV? Regel dan ook de formele overdracht via een aandelenoverdracht.',
            },
            ISSUE_OF_NEW_SHARES: {
                TITLE: 'Uitgifte aandelen',
                DESCRIPTION: 'Extra kapitaal ophalen voor de BV? Dit regel je eenvoudig via een uitgifte van nieuwe aandelen.',
            },
            AANDELENFUSIE: {
                TITLE: 'Aandelenfusie',
                DESCRIPTION:
                    'Ben je ooit begonnen met enkel een BV en wil je nu toch overstappen naar een holdingstructuur? Met een holdingstructuur geniet je van de vele (fiscale) voordelen.',
            },
            CERTIFICATION_SHARES_STAK: {
                TITLE: 'Certificering aandelen (STAK)',
                DESCRIPTION: 'Een stichting administratiekantoor, ook wel een STAK genoemd, scheidt het winstrecht van de stemrecht bij een aandeel.',
            },
            LIQUIDATION_BV: {
                TITLE: 'BV opheffen',
                DESCRIPTION: 'Wanneer je een BV wilt opheffen.',
            },
            LIQUIDATION_FOUNDATION: {
                TITLE: 'Stichting opheffen',
                DESCRIPTION: 'Wanneer je een Stichting wilt opheffen.',
            },
            LIQUIDATION_ASSOCIATION: {
                TITLE: 'Vereniging opheffen',
                DESCRIPTION: 'Wanneer je een Vereniging wilt opheffen.',
            },
            EASY_BV: {
                TITLE: '1-Persoons BV',
                DESCRIPTION: [
                    '1 aandeelhouder (natuurlijk persoon)',
                    'Beheersing van de Nederlandse taal',
                    'Geboren en woonachtig in Nederland',
                    '€ 1,20 aandelenkapitaal',
                ],
                DETAILS: [
                    'Je gaat een BV oprichten met 1 aandeelhouder. Minimum leeftijd 18 jaar.',
                    'Je bent als persoon rechtstreeks aandeelhouder van de nieuwe BV. Niet via een bestaande holding.',
                    'Je moet de Nederlandse taal beheersen. Dit betreft zowel spreken als lezen. Dit zal door de notaris worden gecontroleerd.',
                    'Je woont officieel in Nederland volgens de BRP (geen postadres) en bent in Nederland geboren.',
                    'De BV heeft 120 aandelen met een waarde van €0,01 per aandeel. Het totale aandelenkapitaal is €1,20. Dit is de meest gebruikelijke.',
                ],
            },
            EASY_REGULAR_BV: {
                TITLE: 'Regular BV',
                DESCRIPTION: [
                    '1 of meerdere aandeelhouders',
                    'Beheersing van de Nederlandse of Engelse taal',
                    'Woonachtig in Nederland',
                    'Vrije keuze aandelenkapitaal',
                ],
                DETAILS: [
                    'Je gaat een BV oprichten met 1 of meerdere aandeelhouders. Minimum leeftijd 18 jaar.',
                    'Alle aandeelhouders zijn de Nederlandse of engelse taal machtig. Dit betreft zowel spreken als lezen. Dit zal door de notaris worden gecontroleerd.',
                    'Alle aandeelhouders wonen officieel in Nederland volgens de BRP (geen postadres).',
                ],
            },
            EASY_FOREIGNER_BV: {
                TITLE: 'Buitenland woonachtig',
                DESCRIPTION: [
                    '1 of meerdere aandeelhouders',
                    'Beheersing van de Nederlandse of Engelse taal',
                    'Niet woonachtig in Nederland',
                    'Vrije keuze aandelenkapitaal',
                ],
                DETAILS: [
                    'Je gaat een BV oprichten met 1 of meerdere aandeelhouders. Minimum leeftijd 18 jaar.',
                    'Alle aandeelhouders zijn de Nederlandse of engelse taal machtig. Dit betreft zowel spreken als lezen. Dit zal door de notaris worden gecontroleerd.',
                    'Eén of meerdere aandeelhouders zijn niet woonachtig in Nederland.',
                ],
            },
            UBO_REGISTRATION: {
                TITLE: 'Ubo',
                DESCRIPTION: 'Wanneer je de UBO wilt inschrijvingen.',
            },
            JOBS: {
                TITLE: 'Andere diensten',
                DESCRIPTION: 'Vind hier alle andere diensten.',
            },
        },
    },
};
